import { connect } from 'react-redux'
import Layout from './components/App/Layout'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ auth: state.auth, routing: state.routing }), mapDispatchToProps)(Layout)
